/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Navigate_ErrorInputs */

const vi_qr_navigate_error = /** @type {(inputs: Qr_Navigate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy đơn hàng. Kiểm tra lại mã.`)
};

/**

* @param {Qr_Navigate_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_navigate_error = /** @type {((inputs?: Qr_Navigate_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Navigate_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_navigate_error(inputs)
});